import * as Sentry from '@sentry/react';

interface ErrorFallbackProps {
  error: Error;
  resetError: () => void;
}

function ErrorFallback({ error, resetError }: ErrorFallbackProps) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-surface-app">
      <div className="bg-surface-app-elevated border border-white/10 p-8 rounded-lg shadow-md max-w-md">
        <h2 className="font-display text-xl font-semibold tracking-tight text-brand-warm mb-4">Something went wrong</h2>
        <p className="text-ink-secondary mb-4">{error.message}</p>
        <button
          onClick={resetError}
          className="px-4 py-2 bg-brand-primary text-white rounded hover:bg-brand-primary-hover"
        >
          Try again
        </button>
      </div>
    </div>
  );
}

export function SentryErrorBoundary({ children }: { children: React.ReactNode }) {
  return (
    <Sentry.ErrorBoundary
      fallback={({ error, resetError }) => (
        <ErrorFallback error={error as Error} resetError={resetError} />
      )}
    >
      {children}
    </Sentry.ErrorBoundary>
  );
}
